module.exports = __webpack_public_path__ + "img/8.fe449a74.jpg";